import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NAV_LINKS, SERVICES, COMPANY } from "../data/site";
import { api } from "../lib/api";

export default function SiteFooter() {
  const [contact, setContact] = useState({ zip: COMPANY.zip, address: COMPANY.address, tel: COMPANY.tel });
  useEffect(() => {
    api
      .get("/company")
      .then((r) => {
        if (r.data?.contact) setContact((c) => ({ ...c, ...r.data.contact }));
      })
      .catch(() => {});
  }, []);
  return (
    <footer data-testid="site-footer" className="relative border-t border-line bg-black">
      <div className="mx-auto max-w-7xl px-4 pt-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 pb-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4">
              <img src="/neo-logo.png" alt="NEO CONSTRUCTION 株式会社ネオ建設" className="h-14 w-auto rounded-[6px]" />
              <span>
                <span className="block text-base font-bold tracking-[0.12em] text-white">株式会社ネオ建設</span>
                <span className="mt-0.5 block font-mono text-[10px] tracking-[0.25em] text-accent">NEO CONSTRUCTION</span>
              </span>
            </div>
            <p className="mt-6 font-mincho text-lg font-bold text-gray-200">土地を整え、未来をつくる。</p>
            <p className="mt-4 text-sm leading-relaxed text-gray-500">
              {COMPANY.name}
              <br />
              {contact.zip} {contact.address}
              <br />
              TEL {contact.tel}
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.35em] text-accent">SITEMAP</p>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="flex items-baseline gap-2 font-display text-sm font-semibold tracking-[0.2em] text-gray-400 transition-colors hover:text-white">
                    {l.label}
                    <span className="font-sans text-xs tracking-normal text-gray-600">{l.ja}</span>
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/contact" className="flex items-baseline gap-2 font-display text-sm font-semibold tracking-[0.2em] text-gray-400 transition-colors hover:text-white">
                  CONTACT
                  <span className="font-sans text-xs tracking-normal text-gray-600">お問い合わせ</span>
                </Link>
              </li>
            </ul>
          </div>
          <div className="lg:col-span-4">
            <p className="font-mono text-[10px] tracking-[0.35em] text-accent">SERVICE</p>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/service#${s.slug}`} className="flex items-baseline gap-3 text-sm text-gray-400 transition-colors hover:text-white">
                    <span className="font-display text-base font-bold text-accent">{s.num}</span>
                    {s.titleJa}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <p aria-hidden className="select-none text-center font-display text-[11vw] font-extrabold leading-[0.9] text-stroke lg:text-[6.5rem]">
          NEO CONSTRUCTION
        </p>
      </div>
      <div className="border-t border-line">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-6 text-xs text-gray-600 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
          <span>
            © 2026 {COMPANY.name} / NEO CONSTRUCTION — 法人番号 {COMPANY.corporateNumber}
          </span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="font-mono tracking-[0.2em] transition-colors hover:text-accent">
            ADMIN
          </Link>
        </div>
      </div>
    </footer>
  );
}
